export class ApiErrorTracking {
  Category: string;
  Action: string;
  Label: string;
  UserId: number;
}
